// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1KenJ","title":"ClientInsurance_title__3rY_6","itemText":"ClientInsurance_itemText__1lmmG"};